export const CUSTOM_EVENTS = {
    "MEDIA_EXPIRED":'MEDIA_EXPIRED',
    "INIT_FAIL":"INIT_FAIL",
    "PARSE_ERROR":"PARSE_ERROR",
    "BUFFERED_RESET": "BUFFERED_RESET"
}

export const TASK_ERROR = 'TASK_ERROR';

export const TASK_ERROR_TYPES = {
    ERROR:"ERROR",
    CODE_ERROR:"CODE_ERROR",
    CANCEL:"CANCEL",
}
